import React, { useState, useEffect } from "react";

import {
  IonButton,
  IonCheckbox,
  IonCol,
  IonIcon,
  IonGrid,
  IonItem,
  IonLabel,
  IonModal,
  IonRow,
  IonSearchbar,
} from "@ionic/react";

import { close } from "ionicons/icons";
import { CONSTANTS } from "../../../constants";
import _ from "lodash";
import DoctorList from "../../Shared/DoctorList/doctor-list";
import "./GroupMediaShare.scss";
import { doctorListInputData } from "../DoctorList/doctor-list.model";
import { utilService } from "../../../services/utilService";
import { rolePermissionsService } from "../../../services/rolePermissions.service";
import MediaUpload from "../../../pages/FileShare/components/MediaUpload/MediaUpload";
import GroupSmsAccordion from "../HomeGroupSms/GroupSmsAccordion/GroupSmsAccordion";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";


interface groupMediaShareProps {
  showModal: boolean;
  onCancel: () => void;
  onOk: () => void;
  doctorListDataFromParent: any;
  patientId?: any;
  accordionList?: any;
  isFromHomeGroupMedia?: any;
}

const GroupMediaShare: React.FC<groupMediaShareProps> = (props) => {
  const [searchText, setSearchText] = useState("");
  const [comment, setComment] = useState<string>("");
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [isSelectAll, setSelectAll] = useState(false);
  const [isCheckedAll, setCheckedAll] = useState(false);
  const [selectedDoctorCard, setSelectedDoctorDetails]: any = useState([]);
  const [selectedAllStatus, setSelectedAllStatus] = useState(false);
  const [disableSendButton, setDisableSendButton] = useState(true);
  const [apiParams, setApiParams]: any = useState({});
  const [doctorData, setDoctorData]: any = useState([]);
  const [hideMediaShareContent, setHideMediaShareContent] = useState(false);
  const [isSmallScreen, setIsSmallScreen]: any = useState(false);
  const { t } = useTranslation("teams");
  const [accordionListFromParent, setAccordionListFromParent]: any = useState({
    own: {},
    added: {},
  });

  const getAllStatus = (dataFromChild: any) => {
    if (dataFromChild) {
      setSelectAll(dataFromChild);
      setCheckedAll(true);
    } else {
      setSelectAll(dataFromChild);
      setCheckedAll(false);
    }
  };

  useEffect(() => {
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
    checkIfSmallScreen();
  }, []);

  useEffect(() => {
    setDoctorData(props.doctorListDataFromParent);
  }, [props.doctorListDataFromParent]);

  useEffect(() => {
    disableGroupSmsButton();
  }, [selectedDoctorCard]);

  useEffect(() => {
    if (selectedAllStatus === true) {
      setSelectAll(true);
    }
  }, [selectedAllStatus]);

  useEffect(() => {
    setCheckedAll(isSelectAll);
  }, [isSelectAll]);

  useEffect(() => {
    getNonEmptyAccordionList();
  }, [props.accordionList]);

  const deleteEmptyObject = (listObject: any) => {
    for (var listObjectItem in listObject) {
      if (listObject[listObjectItem].data.length === 0) {
        delete listObject[listObjectItem];
      }
    }
    return listObject;
  };

  const getNonEmptyAccordionList = () => {
    if (!_.isEmpty(props.accordionList)) {
      const ownListTemp = _.cloneDeep(props.accordionList.own);
      const addedListTemp = _.cloneDeep(props.accordionList.added);
      var ownList = deleteEmptyObject(ownListTemp);
      var addedList = deleteEmptyObject(addedListTemp);
      const accordionList = {
        own: ownList ? ownList : {},
        added: addedList ? addedList : {},
      };
      setAccordionListFromParent(_.cloneDeep(accordionList));
    }
  };

  const selectAll = async (event: any) => {
    setSelectAll(event.detail.checked);
    setCheckedAll(event.detail.checked);
  };

  const getSelectedCard = (selectedCard: any) => {
    if(selectedCard?.length>1){
      let tempStore = selectedDoctorCard
      selectedCard?.forEach((doctor:any) => {
        if(tempStore?.find((selectedDr:any)=>selectedDr?.guid===doctor?.guid)){
          tempStore=tempStore?.filter((selectedDr:any)=>selectedDr?.guid!==doctor?.guid)
        }else{
          tempStore=[...tempStore,doctor]
        }
      });
      setSelectedDoctorDetails(tempStore)
      
    }else{
      if(selectedDoctorCard?.find((user:any)=>user?.guid===selectedCard?.guid&&selectedCard?.isSelected)){
        setSelectedDoctorDetails(selectedDoctorCard?.filter((user:any)=>user?.guid!==selectedCard?.guid))
      }else{
        setSelectedDoctorDetails([...selectedDoctorCard,selectedCard])
      }
    }
  };

  const disableGroupSmsButton = () => {
    if (!selectedDoctorCard.length) {
      setDisableSendButton(true);
    } else {
      setDisableSendButton(false);
    }
  };

  const getSelectAllStatus = (selectedAllStatusFromDoctorList: boolean) => {
    setSelectedAllStatus(selectedAllStatusFromDoctorList);
  };

  const doctorListInput: doctorListInputData = {
    componentName: CONSTANTS.COMPONENTS.GROUP_SMS,
    isMultiSelectEnabled: true,
    isShowColorBadge: false,
  };

  const history = useHistory()

  const setMessageOnSendButtonClick = () => {
    const flattenedDoctors = _.uniqBy(_.flattenDeep(selectedDoctorCard), "guid");
    history.push({
      pathname: "/client/messages",
      state: {
        selectedDoctorData: flattenedDoctors,
        mediaAction: CONSTANTS.MEDIA_ACTIONS.SEND,
        isFullscreen: true,
        isMultiSendEnabled: true,
        pid:props.patientId,
      },
    });
    setHideMediaShareContent(true);
    setSelectAll(false);
  };

  const checkIfSmallScreen = () => {
    if (utilService.getScreenSize() === "small") {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  };

  return (
    <IonModal
      isOpen={props.showModal}
      backdropDismiss={false}
      className="group-media-share-modal"
    >
      <div className="group-media-share-modal-container">
        <div
          className={`close-modal-icon ${
            isSmallScreen && "close-modal-icon-small-screen"
          }`}
          onClick={() => {
            props.onCancel();
            setComment("");
            setSelectAll(false);
            setSearchText("");
            setHideMediaShareContent(false);
          }}
        >
          <IonIcon icon={close} />
        </div>

        {!hideMediaShareContent ? (
          <div
            className={`group-sms-content ${
              isSmallScreen && "group-sms-content-small-screen"
            }`}
          >
            <div className="group-sms-header"> {t("messages")}</div>

            <div className="searchbar-container">
              <div className="select-all-button">
                <IonItem lines="none">
                  <IonCheckbox
                    className="check-box"
                    onIonChange={(event) => selectAll(event)}
                    checked={isSelectAll}
                  ></IonCheckbox>
                  <IonLabel>{t("all")}</IonLabel>
                </IonItem>
              </div>
              <div className="searchbar-containar-item">
                <IonSearchbar
                  value={searchText}
                  onIonChange={(e) => {
                    
                    setSearchText(e.detail.value!)
                  }}
                  placeholder={t("search")}
                  type="search"
                  autocomplete="off"
                  autoCorrect="off"
                  className="searchbar"
                ></IonSearchbar>
              </div>
            </div>
            {!props.isFromHomeGroupMedia && (
              <div className="doctor-card-list-container">
                <IonGrid className="scrollbar">
                  <IonRow>
                    <IonCol>
                      <DoctorList
                        apiParams={apiParams}
                        doctorListInputData={doctorListInput}
                        permissions={rolePermissions}
                        selectedAll={isSelectAll}
                        searchText={searchText}
                        doctorListDataFromParent={doctorData}
                        getSelectedCard={getSelectedCard}
                        getSelectedCardAndSchedule={() => {}}
                        getIsAllSelectedStatus={getSelectAllStatus}
                        getAllCards={() => {}}
                        getAllCardsAndSchedule={() => {}}
                        hideFeatureButtons={true}
                      ></DoctorList>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </div>
            )}
            {props.isFromHomeGroupMedia && (
              <div className="doctor-card-list-container">
                <IonGrid className="scrollbar">
                  <IonRow>
                    <IonCol>
                      <GroupSmsAccordion
                        isCheckedAll={isCheckedAll}
                        getAllStatus={getAllStatus}
                        accordionList={accordionListFromParent}
                        isSelectAll={isSelectAll}
                        searchText={searchText}
                        getSelectedCard={getSelectedCard}
                      />
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </div>
            )}

            <div className="group-sms-button-container">
              <div className="cancel-button-div">
                <IonButton
                  color="medium"
                  className="button secondary-btn  btn-curved"
                  onClick={() => {
                    props.onCancel();
                    setComment("");
                    setSelectAll(false);
                    setSearchText("");
                  }}
                >
                  {t("cancel")}
                </IonButton>
              </div>
              <div className="send-button-div">
                <IonButton
                  className="submit-btn button primary-btn btn-curved"
                  disabled={disableSendButton}
                  onClick={() => {
                    setMessageOnSendButtonClick();
                  }}
                >
                  {t("attachMedia")}
                </IonButton>
              </div>
            </div>
          </div>
        ) : (
          <div className="attach-media-content">
            <MediaUpload
              isGroupMediaShare={true}
              doctorListDataFromParent={selectedDoctorCard}
              onOk={() => {}}
              isShowNamesList={true}
              onCancel={() => {
                setHideMediaShareContent(false);
              }}
              patientId={props.patientId}
              isSmallScreen={true}
            ></MediaUpload>
          </div>
        )}
      </div>
    </IonModal>
  );
};

export default GroupMediaShare;
